import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { CartData } from '@Types/Cart';

interface Params {
  signal?: AbortSignal;
}

async function checkCertificate({ signal }: Params = {}) {
  const url = '/cabinet/cart/check-certificate';
  const res = await Api.queryProxi<{ data: CartData }>(url, {
    signal,
  });

  if (!res.data) throw new BackendError(url, res);

  return res.data;
}

export default checkCertificate;
